import type { JSX } from 'react';
export interface WsContentSearchPaginationProps {
  pageNo: number;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

/**
 * コンテンツ画面 ページネーションコンポーネント
 */
export default function WsContentSearchPagination({
  pageNo,
  hasNext,
  onPrev,
  onNext,
}: WsContentSearchPaginationProps): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <nav aria-label="Page navigation" className="navigation mt-4" style={{ position: 'static' }}>
      <ul className="pagination mb-0">
        <li className="page-item">
          <a
            onClick={onPrev}
            className={`page-link prev ${pageNo <= 1 && `disabled`}`}
            aria-label="Previous"
          >
            <span aria-hidden="true"></span>
          </a>
        </li>
        <li className="page-item">
          <a
            onClick={onNext}
            className={`page-link next ${!hasNext && `disabled`}`}
            aria-label="Next"
          >
            <span aria-hidden="true"></span>
          </a>
        </li>
      </ul>
    </nav>
  );
}
